import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon } from "./Icon";
import { PressButton } from "./PressButton";
import { Text } from "./Text";

const Row = styled("div")`
  display: flex;
  align-items: center;
  border-radius: 8px;
  min-width: 0;
  &:hover {
    background: var(--alpha4);
  }
`;

const ChoiceButton = styled(PressButton)`
  all: unset;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 8px;
  cursor: pointer;
  min-width: 0;
`;

const ChoiceText = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  text-wrap: pretty;
`;

const Accessory = styled("div")`
  display: inline-flex;
  min-width: 0;
  padding-right: 8px;
`;

export function ChoiceRow({
  selected,
  label,
  description,
  accessory,
  onPress,
}: {
  selected: boolean;
  label: string;
  description?: string;
  accessory?: ReactNode;
  onPress: () => void;
}) {
  return (
    <Row>
      <ChoiceButton
        data-no-pill
        role="radio"
        aria-checked={selected}
        onPress={onPress}
      >
        <span style={{ display: "inline-flex", opacity: selected ? 1 : 0.12 }}>
          <Icon name={selected ? "check-filled" : "check-empty"} size={16} />
        </span>
        <ChoiceText>
          <Text variant="text-regular" color="var(--text-primary)">
            {label}
          </Text>
          {description && (
            <Text variant="text-small" color="var(--text-secondary)">
              {description}
            </Text>
          )}
        </ChoiceText>
      </ChoiceButton>
      {accessory && (
        // Capture so the dropdown opener’s stopPropagation can’t swallow the press; click covers iOS taps that drop pointerdown.
        <Accessory
          onPointerDownCapture={(e) => {
            if (e.button === 0) onPress();
          }}
          onClickCapture={onPress}
        >
          {accessory}
        </Accessory>
      )}
    </Row>
  );
}
